export function notify() {
    return new Promise((resolve, reject) => {
        if (!("Notification" in window)) {
            reject('error')
        } else if (Notification.permission === "granted") {
            resolve(true)
        } else if (Notification.permission !== "denied") {
            Notification.requestPermission().then((permission) => {
                if (permission === "granted") {
                    const notification = new Notification("授权成功");
                    setTimeout(() => { notification.close() }, 2000)
                    resolve(true)
                } else {
                    reject('error')
                }
            });
        }
    })
}

let blingCount = 0
let blingTimer = null
export function notifyWebTitle(title) {
    document.title = title
    if (blingTimer) {
        clearInterval(blingTimer)
        blingCount = 0
    }
    blingTimer = setInterval(() => {
        blingCount++
        if (blingCount % 2 === 0) {
            document.title = title
        } else {
            document.title = '万药城'
        }
    }, 500)
}

export function initDocumentTitle (title = '万药城') {
    document.title = title
    if (blingTimer) {
        clearInterval(blingTimer)
        blingCount = 0
    }
}


// WEBPACK FOOTER //
// ./src/libs/utils/notice.js